import { useEffect, useState } from "react";
import { Alert, Button, Modal, Spin } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { getArchivo, mensajeDeError } from "../../../services/manifestacionesInteres/manifestacionesInteresService";

export const descargarDocumento = async (oidManifestacion, documento) => {
  const contenido = await getArchivo(oidManifestacion, documento.oid, "descargar");
  const enlace = document.createElement("a");
  enlace.href = URL.createObjectURL(contenido);
  enlace.download = documento.nombre_fisico;
  enlace.click();
  URL.revokeObjectURL(enlace.href);
};

// El PDF se pide con el token y se muestra desde memoria: nunca hay una URL
// pública ni el token viaja en la dirección.
export default function VisorPdfModal({ oidManifestacion, documento, puedeDescargar, onClose }) {
  const [urlPdf, setUrlPdf] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!documento) return undefined;
    let activo = true;
    let creada = null;
    setUrlPdf(null);
    setError(null);
    getArchivo(oidManifestacion, documento.oid, "ver")
      .then((contenido) => {
        if (!activo) return;
        creada = URL.createObjectURL(contenido);
        setUrlPdf(creada);
      })
      .catch(async (e) => {
        if (activo) setError(await mensajeDeError(e, "No se pudo abrir el documento."));
      });
    return () => {
      activo = false;
      if (creada) URL.revokeObjectURL(creada);
    };
  }, [oidManifestacion, documento]);

  const descargar = async () => {
    try {
      await descargarDocumento(oidManifestacion, documento);
    } catch (e) {
      setError(await mensajeDeError(e, "No se pudo descargar el documento."));
    }
  };

  return (
    <Modal
      open={!!documento}
      title={documento?.nombre_fisico}
      onCancel={onClose}
      width="min(1000px, 96vw)"
      style={{ top: 16 }}
      destroyOnHidden
      footer={[
        puedeDescargar && (
          <Button key="descargar" icon={<DownloadOutlined />} onClick={descargar}>
            Descargar
          </Button>
        ),
        <Button key="cerrar" type="primary" onClick={onClose}>
          Cerrar
        </Button>,
      ]}
    >
      {error && <Alert type="error" showIcon message={error} />}
      {!error && !urlPdf && <div className="text-center py-5"><Spin /></div>}
      {urlPdf && (
        <iframe title="Vista previa del documento" src={urlPdf} style={{ width: "100%", height: "75vh", border: 0 }} />
      )}
    </Modal>
  );
}
